export const NavigationBlock = ({ title, className = '', children }) => (
  <div
    className={`max-sm:flex max-sm:flex-col grid grid-cols-1 md:gap-8 min-w-[120px] ${className}`}
  >
    <div className="space-y-5">
      <div className="text-sm font-semibold text-slate-400 uppercase tracking-[0.7px]">
        {title}
      </div>
      <ul role="list" className="space-y-4">
        {children}
      </ul>
    </div>
  </div>
);
